export default __webpack_public_path__ + "static/media/values.92f0bfaa.svg";